/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminResolveAttentionReq
 */
export interface AdminResolveAttentionReq {
    /**
     * Days to hide the product from the dashboard.
     * @type {number}
     * @memberof AdminResolveAttentionReq
     */
    days: number;
    /**
     * 
     * @type {string}
     * @memberof AdminResolveAttentionReq
     */
    note?: string;
}

export function AdminResolveAttentionReqFromJSON(json: any): AdminResolveAttentionReq {
    return AdminResolveAttentionReqFromJSONTyped(json, false);
}

export function AdminResolveAttentionReqFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminResolveAttentionReq {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'days': json['days'],
        'note': !exists(json, 'note') ? undefined : json['note'],
    };
}

export function AdminResolveAttentionReqToJSON(value?: AdminResolveAttentionReq | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'days': value.days,
        'note': value.note,
    };
}

